
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { services } from '@/services/services'
import ModalBase from '@/views/modal/ModalBase.vue'
import { useStore } from 'vuex'

const service = services.login

export default defineComponent({
  emits: {
    dismiss: () => true
  },
  components: {
    ModalBase
  },
  setup (_, { emit }) {
    const router = useRouter()
    const store = useStore()

    const dismiss = () => {
      emit('dismiss')
    }

    const logout = async () => {
      await service.logout()
      store.commit('setAccountingStartDate', '')
      store.commit('setAccountingEndDate', '')
      await router.push('/login')
    }

    return {
      logout,
      dismiss
    }
  }
})
